import { render, staticRenderFns } from "./textarea.vue?vue&type=template&id=2a4ceb52&scoped=true&lang=pug&"
import script from "./textarea.vue?vue&type=script&lang=js&"
export * from "./textarea.vue?vue&type=script&lang=js&"
import style0 from "./textarea.styl?vue&type=style&index=0&id=2a4ceb52&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4ceb52",
  null
  
)

export default component.exports